import { render, staticRenderFns } from "./PrePostNatalSupport.vue?vue&type=template&id=3b153558&scoped=true&"
import script from "./PrePostNatalSupport.vue?vue&type=script&lang=js&"
export * from "./PrePostNatalSupport.vue?vue&type=script&lang=js&"
import style0 from "./PrePostNatalSupport.vue?vue&type=style&index=0&id=3b153558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b153558",
  null
  
)

export default component.exports